import { Text } from '@mxenabled/mxui'
import { GridCellParams } from '@mui/x-data-grid'
import { DATE_FORMATS_INTL, formatDate } from '@mx-cartographer/experiences'

const CreatedRowCell = (params: GridCellParams) => (
  <Text variant="body2" sx={{ p: 16, width: '100%' }}>
    {formatDate(params.row.created_at, DATE_FORMATS_INTL.YEAR_MONTH_DAY)}
  </Text>
)

export default CreatedRowCell
